import { CardLayoutProps } from 'shared/components/CardLayout/types';
import { memoWithDisplayName } from 'shared/utils/memoWithDisplayName';

import { prepareStyles } from '../../utils/prepareStyles';

import styles from './CardLayoutNarrow.css';

type CardLayoutNarrowProps = Omit<CardLayoutProps, 'isShortListing'>;

export const CardLayoutNarrow = memoWithDisplayName<CardLayoutNarrowProps>(props => {
  const { publisher, content, controls, gallery, thumbnails, vas, onClick, isTop3, isMulti, testId } = props;

  const containerStyles = prepareStyles(styles, { isMulti, isTop3 });

  return (
    <article className={containerStyles} data-testid={testId} onClick={onClick}>
      <div className={styles['media']}>
        <div className={styles['gallery']}>{gallery}</div>
        <div className={styles['thumbnails']}>{thumbnails}</div>
        <div className={styles['publisher']}>{publisher}</div>
      </div>

      <div className={styles['content']}>
        <div className={styles['content-wrapper']}>
          {content}
          <section className={styles['footer']}>
            <section className={styles['controls-container']}>
              {controls}
              <div className={styles['vas']}>{vas}</div>
            </section>
          </section>
        </div>
      </div>
    </article>
  );
}, 'CardLayoutNarrow');
